a.bannerLink {
	@apply
	yst-block
	yst-w-full
	yst-bg-cover
	yst-h-[60px]
	yst-leading-[60px]
	yst-text-[30px]
	yst-text-center
	yst-overflow-hidden
	yst-no-underline
	yst-font-bold
	yst-text-white
	max-[600px]:yst-h-[75px]
	max-[600px]:yst-leading-[35px]
	max-[990px]:yst-text-base;

	.highlight {
		@apply
		yst-text-amber-400
		yst-inline
		yst-pl-5
		yst-underline
		max-[600px]:yst-block;

		img {
			@apply
			yst-inline-block
			yst-transition-transform
			yst-duration-200
			yst-ml-2
			yst-ease-in-out;
		}
	}

	img.tag {
		@apply
		yst-inline-block
		yst-mx-2
		yst-h-[54px]
		yst-rotate-[15deg]
		yst--translate-y-[5px]
		max-[990px]:yst-h-[30px];
	}

	&:hover {
		@apply yst-text-white;

		span img {
			@apply yst-translate-x-2;
		}
	}

	&:active, &:visited, &:focus {
		@apply yst-text-white;
	}
}

.visuallyHidden {
	@apply yst-sr-only;
}
